// extracted by mini-css-extract-plugin
export default {"buttonGroup":"GroupGiftGoalAmountForm-style__buttonGroup__ebZap","customLink":"GroupGiftGoalAmountForm-style__customLink__zIiCi"};